module.exports = __webpack_public_path__ + "static/media/extreme-heat.314205f9.png";